export default "__VITE_ASSET__CVz6nJTd__"